"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWorldInteractUI = void 0;
const pixel_pigeon_1 = require("pixel-pigeon");
const NPC_1 = require("../../../classes/NPC");
const WorldCharacter_1 = require("../../../classes/WorldCharacter");
const createPanel_1 = require("../components/createPanel");
const createPressableButton_1 = require("../components/createPressableButton");
const getConstants_1 = require("../../getConstants");
const definables_1 = require("definables");
const getInteractableEntityCollidable_1 = require("../../getInteractableEntityCollidable");
const getWorldState_1 = require("../../state/getWorldState");
const interact_1 = require("../../interact");
const isAWorldMenuOpen_1 = require("../../world-menus/isAWorldMenuOpen");
const isWorldCombatInProgress_1 = require("../../isWorldCombatInProgress");
const state_1 = require("../../../state");
const createWorldInteractUI = () => {
    // Background panel
    const condition = () => {
        const constants = (0, getConstants_1.getConstants)();
        if (state_1.state.values.worldState !== null) {
            const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, (0, getWorldState_1.getWorldState)().values.worldCharacterID);
            if ((0, isAWorldMenuOpen_1.isAWorldMenuOpen)() === false) {
                if (worldCharacter.hasMovedAt() === false ||
                    (0, pixel_pigeon_1.getCurrentTime)() - worldCharacter.movedAt >=
                        constants["movement-duration"]) {
                    if ((0, getInteractableEntityCollidable_1.getInteractableEntityCollidable)() !== null) {
                        return (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false;
                    }
                }
            }
        }
        return false;
    };
    (0, createPanel_1.createPanel)({
        condition,
        height: 28,
        imagePath: "panels/basic",
        width: 60,
        x: 122,
        y: 180,
    });
    // Interact button
    (0, createPressableButton_1.createPressableButton)({
        condition,
        height: 16,
        imagePath: "pressable-buttons/gray",
        onClick: () => {
            (0, interact_1.interact)();
        },
        text: () => {
            const entityCollidable = (0, getInteractableEntityCollidable_1.getInteractableEntityCollidable)();
            if (entityCollidable === null) {
                throw new Error("No entity collidable.");
            }
            let value;
            switch (entityCollidable.type) {
                case "bank":
                    value = "Bank";
                    break;
                case "chest":
                    value = "Open";
                    break;
                case "combination-lock":
                    value = "Unlock";
                    break;
                case "enterable":
                    value = "Enter";
                    break;
                case "npc": {
                    const npcID = (0, pixel_pigeon_1.getEntityFieldValue)(entityCollidable.entityID, "npcID");
                    if (typeof npcID !== "string") {
                        throw new Error("No NPC ID.");
                    }
                    const npc = (0, definables_1.getDefinable)(NPC_1.NPC, npcID);
                    if (npc.hasDialogue() || npc.hasQuestGiver()) {
                        value = "Talk";
                    }
                    if (npc.hasInnCost()) {
                        value = "Rest";
                    }
                    if (npc.hasShopID()) {
                        value = "Shop";
                    }
                    if (npc.hasEncounterID()) {
                        value = "Fight";
                    }
                    break;
                }
                case "piano":
                    value = "Play";
                    break;
            }
            if (typeof value === "undefined") {
                throw new Error("No value.");
            }
            return {
                value,
            };
        },
        width: 48,
        x: 128,
        y: 186,
    });
};
exports.createWorldInteractUI = createWorldInteractUI;
